import { CakeAppExtensionProvider } from "../../extensions/cake/cake.app.extension.provider";
import { ConciergeAppExtensionProvider } from "../../extensions/concierge/concierge.app.extension.provider";
import { MMAdminAppExtensionProvider } from "../../extensions/mmadmin/mmadmin.app.extension.provider";
import { NEOAppExtensionProvider } from "../../extensions/neo/neo.app.extension.provider";
import { AzureAppContextProvider } from "../authentication/azure/azure.app.context";
import { DescopeAppContextProvider } from "../authentication/descope/descope.app.context";
import { KeycloakAppContextProvider } from "../authentication/keycloak/keycloak.app.context";


export class AppInitialization {

    public static async initAppContext() {
        const activeDirectory = new AzureAppContextProvider();
        const keycloak = new KeycloakAppContextProvider();
        const descope = new DescopeAppContextProvider();
        const cake = new CakeAppExtensionProvider();
        const concierge = new ConciergeAppExtensionProvider();
        const mmadmin = new MMAdminAppExtensionProvider();
        const neo = new NEOAppExtensionProvider();
    }
}
